<!--
 * @Descripttion: 员工福利
 * @Author: jschen
 * @Date: 2021-08-29 17:26:02
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-12 16:08:25
-->
<template>
    <div class="house-system-container">
        <div class="system-box house-table-box">
            <header class="top-header">
                <div class="breadcrumb">
                    <el-breadcrumb separator="/">
                        <el-breadcrumb-item :to="{ path: '/work-portal/user-center' }">
                            <i class="icon-home"></i> 个人中心
                        </el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '/work-portal/name-welfare' }">工牌福利</el-breadcrumb-item>
                        <el-breadcrumb-item>福利详情</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </header>
            <div class="center-context">
                <div>
                    <welfare-item></welfare-item>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import WelfareItem from "./components/welfare-item.vue";
export default {
    name: "WelfareActivitiesDetails",
    components: {
        WelfareItem,
    },
};
</script>
<style lang="scss" scoped>
@import "./style.scss";
</style>
